import React from "react";
import { Link } from "react-router-dom";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import AddToCartButton from "./AddToCartButton";
import { useWishlist } from "../context/WishlistContext";
import "../css/productcard.css";

function ProductCard({ product, productImageUrl }) {
  const { enabled: wishlistEnabled, isWishlisted, toggle } = useWishlist();
  const price = product.is_on_sale ? product.sale_price : product.sell_price;

  const discountPercent =
    product.is_on_sale && product.compare_price
      ? Math.round(
          ((product.compare_price - product.sale_price) / product.compare_price) * 100
        )
      : 0;

  return (
    <div className="pcard-comp">
      {/* Image */}
      <div className="pcard-comp-img-wrap">
        <Link to={`/product/${product._id}`}>
          <img
            src={productImageUrl || "/images/default-product.jpg"}
            alt={product.name}
            className="pcard-comp-img"
            loading="lazy"
            decoding="async"
            onError={(e) => { e.target.src = "/images/default-product.jpg"; }}
          />
        </Link>
        {discountPercent > 0 && (
          <span className="pcard-comp-badge">-{discountPercent}%</span>
        )}
        {wishlistEnabled && (
          <button
            type="button"
            aria-label="Save to wishlist"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(product._id); }}
            style={{
              position: "absolute", top: 8, right: 8, width: 34, height: 34, borderRadius: "50%",
              border: "none", background: "rgba(255,255,255,0.92)", boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
              display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
              color: "#444", fontSize: 15, zIndex: 2,
            }}
          >
            {isWishlisted(product._id) ? <FaHeart color="#e0245e" /> : <FaRegHeart />}
          </button>
        )}
      </div>

      {/* Body */}
      <div className="pcard-comp-body">
        <Link to={`/product/${product._id}`} className="pcard-comp-name-link">
          {/* CSS handles 2-line clamp — no JS truncation needed */}
          <div className="pcard-comp-name" title={product.name}>
            {product.name}
          </div>
        </Link>

        {product.weight && (
          <div className="pcard-comp-weight">{product.weight}</div>
        )}

        <div className="pcard-comp-price-row">
          {product.is_on_sale ? (
            <>
              <span className="pcard-comp-old">
                ₩{(product.compare_price || product.sell_price)?.toLocaleString()}
              </span>
              <span className="pcard-comp-price">₩{price?.toLocaleString()}</span>
            </>
          ) : (
            <span className="pcard-comp-price">₩{price?.toLocaleString()}</span>
          )}
        </div>

        {/* Original AddToCartButton — logic fully preserved */}
        <AddToCartButton product={{ ...product, newPrice: price }} />
      </div>
    </div>
  );
}

export default ProductCard;